/* eslint-disable @tencent/i18next/no-literal-string */
import { browser, getiOSVer } from '@src/slide/infrastructure/module/independent/agent/common';

export const FontConvertItems = [
    {
        fontFamily: 'Agency FB', // 细字体
        toFontFamily: 'Agency FB,DIN Condensed,Arial Narrow',  // 替换后字体
    },
    {
        fontFamily: '腾讯体 W3', // 细字体
        toFontFamily: 'TencentSans W3,腾讯体 W3,TencentSans,腾讯体',  // 替换后字体
    },
    {
        fontFamily: '腾讯体W3', // 细字体
        toFontFamily: 'TencentSans W3,腾讯体 W3,TencentSans,腾讯体',  // 替换后字体
    },
    { fontFamily: '腾讯体 W7', toFontFamily: 'TencentSans W7,腾讯体 W7,TencentSans,腾讯体' },   // 替换后字体
    { fontFamily: '腾讯体W7', toFontFamily: 'TencentSans W7,腾讯体 W7,TencentSans,腾讯体' },   // 替换后字体
    { fontFamily: '腾讯体', toFontFamily: 'TencentSans W3,腾讯体 W3,TencentSans,腾讯体' },   // 替换后字体
    { fontFamily: 'TencentSans W3', toFontFamily: 'TencentSans W3,腾讯体 W3,TencentSans,腾讯体' },   // 替换后字体
    { fontFamily: 'TencentSans W7', toFontFamily: 'TencentSans W7,腾讯体 W7,TencentSans,腾讯体' },   // 替换后字体
    { fontFamily: 'TencentSans Korean W3', toFontFamily: 'TencentSans Korean W3,TencentSans Korean,腾讯体' },   // 替换后字体
    { fontFamily: 'TencentSans Korean W7', toFontFamily: 'TencentSans Korean W7,TencentSans Korean,腾讯体' },   // 替换后字体
];

export const DefaultFamily = 'Helvetica Neue,Helvetica,PingFang SC,Microsoft YaHei,Source Han Sans SC,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif';

/**
 * 字体在转换数组中，返回相应对象，否则返回undefined
 * @param fontFamily
 */
export function isFontInConvertItems(fontFamily) {
    for (let i = 0; i < FontConvertItems.length; i++) {
        const item = FontConvertItems[i];
        if (item.fontFamily === fontFamily) {
            return item;
        }
    }
}


// eslint-disable-next-line complexity
function fontFamilyConvert(fontFamily) {
    if (!fontFamily) return [];

    const arr = [fontFamily];
    switch (fontFamily) {
        case 'SimSun':
        case '宋体':
            arr.push('SimSun,宋体,Songti SC');
            break;
        case 'SimHei':
        case '黑体':
            arr.push('SimHei,黑体,Heiti SC');
            break;
        case 'FangSong':
        case '仿宋':
            arr.push('FangSong,仿宋');
            break;
        case 'KaiTi':
        case '楷体':
            arr.push('KaiTi,楷体,KaiTi SC');
            break;
        case 'STFangsong':
        case '华文仿宋':
            arr.push('STFangsong,华文仿宋');
            break;
        case 'STKaiti':
        case '华文楷体':
            arr.push('STKaiti,华文楷体');
            break;
        case 'STSong':
        case '华文宋体':
            arr.push('STSong,华文宋体');
            break;
        case 'Hiragino Sans GB':
        case '冬青黑简体中文':
            arr.push('Hiragino Sans GB,冬青黑简体中文');
            break;
        case 'Microsoft YaHei':
            // eslint-disable-next-line @tencent/i18next/no-literal-string
            arr.push('微软雅黑, Roboto, sans-serif');
            break;
        case '微软雅黑':
            arr.push('Microsoft YaHei, Roboto, sans-serif');
            break;
        case '默认字体':
            arr.unshift(DefaultFamily);
            break;
        default:
            break;
    }

    fixSTFontFamily(fontFamily, arr);

    return arr;
}

// 对ST字体兼容，参考core-doc中使用的ace.js
function fixSTFontFamily(fontFamily, arr) {
    if (fontFamily && fontFamily.indexOf('ST') > -1) {
        if (fontFamily === 'STSong') {
            arr.push('SimSun');
        } else {
            arr.push(fontFamily.slice(2));
        }
    }
}

export function fontFamilysConvert(fontFamilys) {
    let s = fontFamilys.reduce((prev, fontFamily) => prev.concat(fontFamilyConvert(fontFamily)), []);

    // 去除重复的
    s = s.filter((fontFamily, index) =>
        // 如果之前没有返回true，有返回false
        s.slice(0, index).indexOf(fontFamily) === -1);

    return s.join(',');
}

/**
 * 特殊字体转换，如果本地没有此字体，转换为接近字体
 */
export function specialFontConvert(fontFamily) {
    if (fontFamily) {
        if (fontFamily.indexOf(',') > 0) {
            const fonts = fontFamily.split(',');
            let convertItem;
            fonts.forEach((font) => {
                const item = isFontInConvertItems(font);
                if (item) {
                    convertItem = item;
                }
            });
            if (convertItem) {
                return convertItem.toFontFamily;
            }
        } else {
            const item = isFontInConvertItems(fontFamily);
            if (item) {
                return item.toFontFamily;
            }
        }
    }

    return fontFamily;
}

/**
 * 过滤掉 ios15 中导致页面崩溃的字体
 * @param fontFamily
 * @returns
 */
export function filterOutIos15CrashFontFamily(fontFamily: string): string {
    try {
        if (browser.isIOS) {
            const iosVersion = getiOSVer();
            // ios 15.0 在 canvas 绘制中文时使用了 '-apple-system' 字体会导致页面崩溃。https://github.com/antvis/G2/issues/3635
            // system-ui 字体也有这个问题
            if (iosVersion && iosVersion >= 150000 && iosVersion < 151000) {
                return fontFamily.split(',')
                    .filter(d => !d.includes('apple-system') && !d.includes('system-ui'))
                    .join(',');
            }
        }
        return fontFamily;
    } catch (err) {
        return fontFamily;
    }
}

/**
 * 给每个 fontFamily 加上引号
 * 避免 canvas 渲染的时候字体显示不正确
 * @param fontFamily
 */
function wrapperFontFamilyWithQuotes(fontFamily: string): string {
    try {
        return fontFamily.split(',')
            .map((font) => {
                // 去除首尾空格
                const fontString = font.trim();
                if (fontString.startsWith('"') || fontString.startsWith('\'')) {
                    return fontString;
                }
                // 如果当前字体不是用 " 或 ' 开头，说明没用引号包装过
                return `"${fontString}"`;
            })
            .join(',');
    } catch (err) {
        return fontFamily;
    }
}

/**
 * 合法化 canvas 中的字体
 * @param fontFamily
 * @returns
 */
export function validateCanvasFontFamily(fontFamily: string): string {
    const filteredFontFamily = filterOutIos15CrashFontFamily(fontFamily);
    return wrapperFontFamilyWithQuotes(filteredFontFamily);
}

/**
 * 处理 textRun 的 fontFamily，转换为最终要渲染的字体
 * @param fontFamily
 * @returns
 */
export function processTextFontFamily(fontFamily: string): string {
    // 初步转换
    let finalFontFamily = fontFamilysConvert([fontFamily]);
    // 特殊字体转换
    finalFontFamily = specialFontConvert(finalFontFamily);
    // 合法化
    return validateCanvasFontFamily(finalFontFamily);
}
